import * as React from 'react';
import EmbeddedPowerBIReport from '../../../../../components/Reporting';
import { ReportingTabProps } from '../../../../../types/reporting.type';

const ReferralReport: React.FunctionComponent<ReportingTabProps> = (props) => {
    const { reportName } = props;
    const REFERRAL_REPORT_ID = 'dc399ede-7c43-4c73-b900-4a319eb425e9';
    const REFERRAL_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';

    return (
        <>
            <EmbeddedPowerBIReport
                reportId={REFERRAL_REPORT_ID}
                workspaceId={REFERRAL_WORKSPACE_ID}
                reportName={reportName}
                hideFilters
                waitForPrimary
            />
        </>
    );
};

export default ReferralReport;
